import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Heading,
  VStack,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Text,
} from "@chakra-ui/react";
import { addIdee } from "../../service/api";

const AddIdee = () => {
  const [formData, setFormData] = useState({
    kurzfassung: "",
    idee: "",
    von: "",
    datum: "",
  });

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modalMessage, setModalMessage] = useState("");

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const addNewIdee = async () => {
    try {
      const response = await addIdee(
        formData.kurzfassung,
        formData.idee,
        formData.von,
        formData.datum
      );
      setModalMessage(response?.data?.message || "Idee erfolgreich hinzugefügt!");
      onOpen();
    } catch (error) {
      setModalMessage("Fehler beim Speichern der Idee.");
      onOpen();
    }
  };

  return (
    <Container maxW="lg" py={{ base: 6, md: 10 }}>
      <Box
        bg="gray.50"
        p={{ base: 5, md: 8 }}
        borderRadius="2xl"
        border="1px solid"
        borderColor="gray.200"
        boxShadow="md"
      >
        <Heading
          mb={{ base: 4, md: 6 }}
          bgGradient="linear(to-r, teal.500, blue.400)"
          bgClip="text"
          fontSize={{ base: "xl", md: "2xl" }}
          textAlign="center"
        >
          Neue Idee hinzufügen
        </Heading>

        <VStack spacing={5} align="stretch">
          <FormControl isRequired>
            <FormLabel>Kurzfassung</FormLabel>
            <Input
              placeholder="Kurzfassung"
              name="kurzfassung"
              value={formData.kurzfassung}
              onChange={handleChange}
              focusBorderColor="teal.400"
              fontSize={{ base: "sm", md: "md" }}
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Idee</FormLabel>
            <Textarea
              placeholder="Beschreibe deine Idee..."
              name="idee"
              value={formData.idee}
              onChange={handleChange}
              resize="vertical"
              minH="120px"
              focusBorderColor="teal.400"
              fontSize={{ base: "sm", md: "md" }}
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Von</FormLabel>
            <Input
              placeholder="Bearbeitet von"
              name="von"
              value={formData.von}
              onChange={handleChange}
              focusBorderColor="teal.400"
              fontSize={{ base: "sm", md: "md" }}
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Datum</FormLabel>
            <Input
              type="date"
              name="datum"
              value={formData.datum}
              onChange={handleChange}
              focusBorderColor="teal.400"
              fontSize={{ base: "sm", md: "md" }}
            />
          </FormControl>

          <Button
            onClick={addNewIdee}
            bgGradient="linear(to-r, teal.500, blue.400)"
            _hover={{ bgGradient: "linear(to-r, teal.600, blue.500)" }}
            size={{ base: "sm", md: "md" }}
          >
            Idee hinzufügen
          </Button>

          <Button
            as="a"
            href="/ideen"
            variant="ghostOutline"
            size={{ base: "sm", md: "md" }}
          >
            Zurück zur Übersicht
          </Button>
        </VStack>
      </Box>

      {/* Rückmeldungs-Modal */}
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Rückmeldung</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>{modalMessage}</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="teal" mr={3} onClick={onClose}>
              Schließen
            </Button>
            <Button variant="outline" as="a" href="/ideen">
              Zurück zur Anzeige
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Container>
  );
};

export default AddIdee;
